import { Injectable } from "@angular/core";
import { Usecase } from "../../../../domain/usecase/usecase.interface";
import { Result } from "../../../../domain/models/http-response.model";
import { AuthRepository } from "../../../../domain/repositories/auth.repository";

@Injectable({ providedIn: 'root' })
export class ForgotPasswordUseCase implements Usecase<string, void> {
  constructor(
    private authReposotry: AuthRepository
  ) {}

  execute(email: string): Promise<Result<undefined, Error>> {
    return this.authReposotry.forgotPassword(email);
  }
}
